export default __webpack_public_path__ + "static/media/referenzen_intro_web-sm@1x.39e22304.webp";